import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { NavbarComponent } from '../../../../layouts/Navbar';
import { Title } from '../../../../layouts/Title';
import style from './Categories.module.scss';

export const CategoriesTop: React.FC = React.memo(() => {
  const intl = useIntl();
  return (
    <div>
      <NavbarComponent dark />
      <div className={classNames('pt-5', style.title)}>
        <Title
          title={intl.formatMessage({
            id: 'web.categories.title',
            defaultMessage: 'Categories'
          })}
        />
      </div>
    </div>
  );
});
